module.exports = __webpack_public_path__ + "static/media/about-bananer.736c364e.png";